const currencySymbols: Record<string, string> = { EUR: '€', USD: '$', GBP: '£' }

export function formatAmount(amount: number, currency: string) {
    const symbol = currencySymbols[currency] ?? currency
    return `${symbol}${amount?.toFixed(2)?.toLocaleString()}`
}
